import type { ConversionStep } from './RouletteConversionChart';

/** 콘텐츠별 차트/테이블에 쓸 이벤트 명 (차트 표시용) */
export const ROULETTE_CONTENT_EVENT_LABELS: Record<string, string[]> = {
  '튜브 낚시': [
    '튜브 낚시\n게임 페이지 진입',
    '시작하기 클릭',
    '인트로 클릭',
    '가이드 클릭',
    '튜브 선택',
    '광고\n유도 페이지\n진입',
    '결과 보고\n티켓 받기 클릭',
    '배너 광고 클릭',
    '다른 게임하고\n티켓 더 받기 클릭',
  ],
  '랜덤 광고 보기': [
    '참여하기 클릭',
    '광고 클릭',
    '티켓 받기 클릭 (1차)',
    '한 장 더 받기 클릭',
    '티켓 받기 클릭 (2차)',
  ],
  '영상 광고 보기': [
    '참여하기 클릭',
    '티켓 받기 클릭 (1차)',
    '티켓 더 받기 클릭',
    '티켓 받기 클릭 (2차)',
  ],
  '홈 방문하기': [
    '참여하기 클릭',
    '광고 보고 보상받기 클릭',
    '광고 클릭',
    '티켓 받기 클릭',
    '티켓 획득 완료',
  ],
  '첫 방문 보상': [
    '온보딩 가이드 노출',
    '시작하기 클릭',
    '약관 동의 바텀시트 노출',
    '동의하고 시작하기 클릭',
    '첫 방문 보상 획득',
    '미션 보상 획득',
  ],
};

/** 선택된 콘텐츠에 맞는 ConversionStep[] 생성 */
export function getConversionDataForContent(selectedContent: string): ConversionStep[] {
  const labels = ROULETTE_CONTENT_EVENT_LABELS[selectedContent];

  if (!labels || labels.length === 0) {
    return [{ label: '-', percentage: 0, count: 0 }];
  }
  return labels.map((label, i) => {
    const pct = i === 0 ? 100 : Math.max(10, 100 - i * 12);
    const count = Math.round(10000 * (pct / 100));
    return { label, percentage: pct, count };
  });
}
